import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../DashboardMain/Header';
import MultiLineChart from './Graph_Pdl';
import styles from './Pdl.module.css';
import Kpis from './Kpis';
import Barchart from './Barchart';
import moment from 'moment';
import * as $ from 'jquery';
import { BotMessageSquare } from 'lucide-react';

const Pdl = () => {
  const [activeTab, setActiveTab] = useState('pdl');
  const navigate = useNavigate();

  const pdlInputRef = useRef(null);
  const tcuInputRef = useRef(null);

  const [pdlVehicle, setPdlVehicle] = useState('cesl');
  const [tcuVehicle, setTcuVehicle] = useState('ace');

  const [filterdata, setFilterData] = useState({
    "startDate": "2026-02-01",
    "endDate": "2026-02-11",
  })

  const formatDateForDisplay = (date) => {
    return date ? moment(date).format('MMM D, YYYY') : '';
  };

  const initDateRange = (ref) => {
    if (!ref.current) return;

    const $input = $(ref.current);

    if ($input.data("daterangepicker")) return;

    $input.daterangepicker({
      showDropdowns: true,
      autoUpdateInput: false,
      locale: {
        format: "MMMM D, YYYY",
        applyLabel: "Apply",
        cancelLabel: "Clear",
      },
    });

    $input.on("apply.daterangepicker", function (ev, picker) {
      setFilterData(prev => ({
        ...prev,
        startDate: picker.startDate.format("YYYY-MM-DD"),
        endDate: picker.endDate.format("YYYY-MM-DD"),
      }));
    });

    $input.on("cancel.daterangepicker", function () {
      setFilterData(prev => ({
        ...prev,
        startDate: null,
        endDate: null,
      }));
    });
  };

  useEffect(() => {
    initDateRange(pdlInputRef);
    initDateRange(tcuInputRef);
  }, []);

  const pdlProjects = activeTab=="pdl"? ['cesl', 'orion', 'kratos']:['ace','coral'];
  const selectedProject = activeTab=="pdl"? pdlVehicle:tcuVehicle
  const hiddenProjects = pdlProjects.filter(p => p !== selectedProject);

  const tcuProjects = ['ace', 'coral'];
  const selectedTcuProject = tcuVehicle;
  const hiddenTcuProjects = tcuProjects.filter(p => p !== selectedTcuProject);

  const selectedProjectFunction=(project)=>{
    if(activeTab=="pdl"){
      setPdlVehicle(project)
    }
    if(activeTab=="tcu"){
      setTcuVehicle(project)
    }
  }

  return (
    <div className="container-fluid p-0">
      <Header />
      <div className={`bg-white border-bottom px-3 ${styles.tabHeader}`}>
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex gap-4">
            <button
              className={`${styles.tabBtn} ${activeTab === 'pdl' ? styles.activeTab : ''}`}
              onClick={() => setActiveTab('pdl')}>
              PDL
            </button>
            <button
              className={`${styles.tabBtn} ${activeTab === 'tcu' ? styles.activeTab : ''}`}
              onClick={() => setActiveTab('tcu')}>
              TCU
            </button>
          </div>
          <div className={styles.botButton}>
            <BotMessageSquare 
            onClick={() =>
              window.open(
                "http://10.164.59.54:2000/summary-chatbot",
                "_blank",
                "noopener,noreferrer"
              )
            }
            className={`ml-auto my-auto cursor-pointer`}/>
            </div>
        </div>
      </div>

      <div className={`bg-light ${styles.contentWrapper}`}>
        {/* {activeTab === 'pdl' && ( */}
          <>
            <div className="px-3 pt-3">
              <Kpis activeTab={activeTab} />
              <div className="px-3 mt-3 d-flex flex-row justify-content-between">
                <div className={styles.projectPillWrapper}>
                  {/* Selected pill */}
                  <span className={`${styles.projectPill} ${styles.active}`}>
                    {selectedProject.toUpperCase()}
                  </span>

                  {/* Hidden pills */}
                  <div className={styles.hiddenPills}>
                    {hiddenProjects.map((project) => (
                      <span
                        key={project}
                        className={styles.projectPill}
                        onClick={() => selectedProjectFunction(project)}>
                        {project.toUpperCase()}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="input-group mt-1 w-25">
                  <input
                    type="text"
                    ref={pdlInputRef}
                    className={`form-control ${styles.customDateRangePicker}`}
                    placeholder="Select date range"
                    value={
                      filterdata.startDate && filterdata.endDate
                        ? `${formatDateForDisplay(filterdata.startDate)} - ${formatDateForDisplay(filterdata.endDate)}`
                        : ""
                    }
                    readOnly
                  />
                </div>
              </div>

              <div className="px-3 pb-3 pt-3">
                <div className={`row g-3 ${styles.graphWrapper}`}>
                  <div className="col-12 col-lg-6 d-flex">
                    <MultiLineChart
                    activeTab={activeTab} 
                      title="Total vs Driven – Vehicle Comparison"
                      filterdata={{ ...filterdata, vehicle:activeTab=="pdl"? pdlVehicle:tcuVehicle }} />
                  </div>
                  <div className="col-12 col-lg-6 d-flex">
                    <Barchart filterdata={{ ...filterdata, vehicle: activeTab=="pdl"? pdlVehicle:tcuVehicle }} activeTab={activeTab}  />
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
    </div>
  );
};

export default Pdl;

